import apiClient from './client';

export async function getPlayerGameStats(gameSlug, token = null) {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await apiClient.get(`/users/me/game-stats/${gameSlug}`, { headers });
  return response.data;
}
